// extracted by mini-css-extract-plugin
module.exports = {"SideNav":"SidePanel_SideNav__nHS0M","SideNavItem":"SidePanel_SideNavItem__3bgeA","SideNavIcon":"SidePanel_SideNavIcon__3tQbb","SideNavText":"SidePanel_SideNavText__1egUu"};